export class ProviderCategoryFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<ProviderCategory>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<ProviderCategory>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ProviderCategoryFilters.attributeTypeMap;
    }
    constructor() {
    }
}
